// extracted by mini-css-extract-plugin
module.exports = {"Navigation":"Navigation_Navigation__SrYjU","BackLink":"Navigation_BackLink__2Fo3S"};